import { useFetch } from '@bingads-webui-campaign/react-hook-use-fetch';
import { ProductAttrubuteStatisticsParams, productAttrubuteStatisticsResponseHandler, productAttrubuteStatisticsRequest } from './productAttributeStatistics';
import { GetListingGroupGridDataParmas, listingGroupGridDataResponseHandler, listingGroupGridDataRequest } from './listingGroupGridData';
import { GetListingGroupConditionsParams, getListingGroupConditionsResponseHandler, getListingGroupConditionsRequest } from './getListingGroupConditions';
import { productOfferRequest, productOfferResponseHandler, ProductOfferParams } from './productOffer';

import { updateListingTree, createRootListingTree } from './updateListingTree';

export function useAPIsOfListingGroup() {
  const { fetch: fetchImpl } = useFetch();

  // baseUrl is not used for now, for we are using a special fetch wrapper
  const baseUrl = '';

  return {
    listingGroupGridData: (params: GetListingGroupGridDataParmas) =>
      listingGroupGridDataResponseHandler(fetchImpl(...listingGroupGridDataRequest(baseUrl, params))),
    productAttributeStatistics: (params: ProductAttrubuteStatisticsParams) =>
      productAttrubuteStatisticsResponseHandler(fetchImpl(...productAttrubuteStatisticsRequest(baseUrl, params))),
    getListingGroupConditions: (params: GetListingGroupConditionsParams) =>
      getListingGroupConditionsResponseHandler(fetchImpl(...getListingGroupConditionsRequest(baseUrl, params))),
    getProductOffers: (params: ProductOfferParams) =>
      productOfferResponseHandler(fetchImpl(...productOfferRequest(baseUrl, params))),
    updateListingTree,
    createRootListingTree,
  };
}
